<div class="feedback-section">
  <span class="feedback-label">Was this relevant to the call?</span>
  <button type="button" class="icon-btn" aria-label="Thumbs up" (click)="toggle('up')">
    <app-euds-svg icon="feather/thumbs-up" size="md" [ngClass]="feedbackState === 'up' ? 'stroke-action-primary' : 'stroke-neutral-medium'"></app-euds-svg>
  </button>
  <button type="button" class="icon-btn" aria-label="Thumbs down" (click)="toggle('down')">
    <app-euds-svg icon="feather/thumbs-down" size="md" [ngClass]="feedbackState === 'down' ? 'stroke-action-primary' : 'stroke-neutral-medium'"></app-euds-svg>
  </button>
</div>
